// extracted by mini-css-extract-plugin
var _1 = "SettingsSidebar-module__animatedBackground--iDSwR";
var _2 = "SettingsSidebar-module__homeButton--nOlXH";
var _3 = "SettingsSidebar-module__section--Hx03w";
export { _1 as "animatedBackground", _2 as "homeButton", _3 as "section" }
